// src/lib/sample-data/spaces.ts
// Re-export from split files to reduce individual file size for Turbopack compatibility
export { spaceIdMapping, allDaysAvailability } from './spaces/spaces-core';
export { sampleSpacesData } from './spaces/spaces-clubs'; 